import { apiUsers } from '@spo/services/api';
import { useQuery } from '@tanstack/react-query';

export const useUserConfig = () => {
  return useQuery({
    queryKey: ['useUserConfig'],
    queryFn: () => apiUsers.getConfiguration(),
  });
};
